"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendedProducts = exports.RECOMMENDED_PRODUCTS_SELECT = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const views_1 = require("./views");
exports.RECOMMENDED_PRODUCTS_SELECT = {
    id: true,
    slug: true,
    title: true,
    images: true,
    category: {
        title: true,
    },
    price: {
        price: true,
        currency: true,
        otherPrices: true,
        lowestPriceBeforeSale: true,
        regularPrice: true,
    },
};
function RecommendedProducts({ className, renderNameTag, label, take, ids, }) {
    const { data, loading } = (0, app_1.useQuery)('getProducts', {
        args: Object.assign(Object.assign({}, (take && { take })), (ids && { ids })),
        select: exports.RECOMMENDED_PRODUCTS_SELECT,
    });
    return ((0, jsx_runtime_1.jsx)(views_1.RecommendedProductsView, { className: className, renderNameTag: renderNameTag, label: label, loading: loading, products: data }));
}
exports.RecommendedProducts = RecommendedProducts;
